import React from 'react';
import { useSkipReasonText } from 'src/components/formEditor/controls/Inputs/base/hooks';
import { useContextSelector } from 'use-context-selector';
import { useScopedTranslation } from '../../../../../application/localisation/useScopedTranslation';
import { Field } from '../../components/Field';
import { RecordContext } from '../../RecordContext';
import { IBmiInputV2 } from 'src/features/forms/base/controls/specials/BmiInputV2';
import { generateBMIDataKeys } from 'src/components/formEditor/uiEditor/provider/formFill.context';

export const BmiInputV2: IBmiInputV2 = ({ dataKey }) => {
  const { t } = useScopedTranslation('Forms.Controls.BMI');

  const dataKeys = generateBMIDataKeys(dataKey);

  const bmiValue = useContextSelector(RecordContext, (v) => v.formResult?.[dataKeys.bmi]);
  const weightValue = useContextSelector(RecordContext, (v) => v.formResult?.[dataKeys.weight]);
  const heightValue = useContextSelector(RecordContext, (v) => v.formResult?.[dataKeys.height]);

  const weightSkipReason = useContextSelector(RecordContext, (v) => v.skipReasons?.[dataKeys.weight]);
  const heightSkipReason = useContextSelector(RecordContext, (v) => v.skipReasons?.[dataKeys.height]);
  const weightSkipReasonText = useSkipReasonText(weightSkipReason);
  const heightSkipReasonText = useSkipReasonText(heightSkipReason);

  return (
    <>
      <Field label={t('Weight')} skipReason={weightSkipReasonText} value={weightValue ? `${weightValue} kg` : ''} />
      <Field label={t('Height')} skipReason={heightSkipReasonText} value={heightValue ? `${heightValue} cm` : ''} />
      <Field label={'BMI'} value={bmiValue} />
    </>
  );
};
